import $ from 'jquery';

export default {

	init() {

		$('.js-donation-btn').on('click', function (e) {

			e.preventDefault();

			$('.js-donation-btn').removeClass(['bg-black', 'text-white']);
			$(this).removeClass(['text-black', 'bg-white']).addClass(['bg-black', 'text-white']);

			const term = $(this).data('type');

			$.ajax({
				url: ajax_object.ajax_url,
				type: 'post',
				dataType: 'json',
				data: {
					action: 'get_donation_list',
					term
				},
				error: function(response) {
					console.error(response);
				},
				success: function( response ) {
					window.history.replaceState(null, null, '?term=' + term);
					$('#JSDonationContainer').html(response.data.html);
				},
			});

		});

	}

};
